import Icon from 'veui/components/Icon'
import { IconBold } from 'dls-icons-vue'

Icon.register('bold', IconBold)
